import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { asJSON2, asJSONSafe } from "../../../functions";
import forms from "../ProtocolForms/forms";
import { toUIDate } from "../../../functions/dateHelpers";
import QRCode from "qrcode";
import { Font } from "@react-pdf/renderer";
import TimesNewRomanBoldItalic from '../../../components/PDFGenerator/fonts/Times New Roman Bold Italic.ttf'
import TimesNewRomanBold from '../../../components/PDFGenerator/fonts/Times New Roman Bold.ttf'
import TimesNewRomanItalic from '../../../components/PDFGenerator/fonts/Times New Roman Italic.ttf'
import TimesNewRoman from '../../../components/PDFGenerator/fonts/Times New Roman.ttf'
import { generateLink, renderPageNumeration, renderPageNumerationAndWatermark } from "../../../functions/renderProtocol";
import htmlConverter from 'html2json'
import { formatNumber } from "../../../functions/formatters";
import { normalizeHtmlTable, applyPdfRowspanClasses } from "../../../functions/pdfMake/normalizeHtmlTable";


pdfMake.vfs = pdfFonts.pdfMake.vfs;


var htmlToPdfmake = require("html-to-pdfmake");
Font.register({
    family: 'Times New Roman',
    src: TimesNewRoman,
})
Font.register({
    family: 'Times New Roman Italic',
    src: TimesNewRomanItalic,
})
Font.register({
    family: 'Times New Roman Bold',
    src: TimesNewRomanBold,
})
Font.register({
    family: 'Times New Roman Bold Italic',
    src: TimesNewRomanBoldItalic,
})


export const ClientPdf = ({ open, handleClose, number, date, protocol, clientPdf, setClientPdf }) => {
    const formatTime = Intl.DateTimeFormat('ru-RU', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    }).format
    const [data, setData] = useState(null);
    const [dataUrl, setDataUrl] = useState(null);
    const [loading, setLoading] = useState(false);


    const fetch = async () => {
        setLoading(true);
        const form = forms[protocol.form?.number];
        const fields = form.fields;
        //  const response = await QRCode.toDataURL(url);
        const data = asJSONSafe(protocol.data);
        let qrLink = null;

        let link = generateLink(protocol.id, protocol.guid);
        if (link) {
            qrLink = await QRCode.toDataURL(link.url)
        }


        const content = [
            [`Номер: ${number}`],
            [`Дата: ${date}`]
        ];

        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            const label = field.label;
            const id = field.id;
            if (field.type == "table") {
                if (field.version == 2) {
                    try {
                        let html = htmlConverter.json2html(data[id]);

                        //console.log('html1: ' + html);

                        //debugger;
                        html = normalizeHtmlTable(html, 2);
                        const e = htmlToPdfmake(html);
                        applyPdfRowspanClasses(e);
                        content.push([e])
                    } catch (e) {
                        console.error(e);
                    }
                }
              // console.log(asJSONSafe(data[id]));
          //      const html = htmlConverter.json2html(value2);
            } else {
                const value = data[id];
                content.push([`${label}: ${value || ""}`]);
            }
        }


  //      content.push([`Результат: ${data?.complied_with_regulatory_doc || data?.research_result || data?.research_results || ''}`]);

        const docDefinition = {
            info: {
                title: 'Результат исследования для клиента',
                author: 'NCE',
                subject: 'Result'
            },
            pageOrientation: 'landscape',
            pageSize: 'A4',
            pageMargins: [56, 28, 28, 28],
            content:
                [
                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 1,
                            widths: ['*', '*'],

                            body: [
                                ['Қазақстан Республикасының Денсаулық сақтау министрлігі\nМинистерство здравоохранения Республики Казахстан', `Қазақстан Республикасының Денсаулық сақтау министрінің 2021 жылғы 20 тамыздағы №ҚР ДСМ-84 бұйрығымен бекітілген №${formatNumber(protocol?.form.number)} нысанды медициналық құжаттама`],
                                [`Қазақстан Республикасы Денсаулық сақтау министрлігі ҚСЭК «Ұлттық сараптама орталығы» ШЖҚ республикалық мемлекеттік кәсіпорнының Астана қаласы бойынша филиалы\n\n${protocol?.filial?.name}`,
                                    `Медицинская документация Форма №${formatNumber(protocol?.form.number)} Утверждена приказом Министра здравоохранения Республики Казахстан от 20 августа 2021 года №ҚР ДСМ-84`],
                            ]
                        }
                    },
                    { text: `${form?.kazakhName + '\n' + form?.name}`, fontSize: 12, alignment: 'center', marginTop: 10 },
                    {
                        text: `№${protocol.number} ${Intl.DateTimeFormat('ru-RU', {
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric'
                        }).format(new Date(protocol?.createdAt))}`, fontSize: 12, alignment: 'center', marginTop: 10, marginBottom: 10
                    },
                    {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            //dontBreakRows: true,
                            widths: ['*'],
                            body: content
                        },
                    },

                    { text: `Исполнитель (лаборант): ${protocol?.performer?.fullName}`, fontSize: 12, marginTop: 10 },
                    { image: qrLink },

                ],
            styles: {
                header: {
                    alignment: 'center',
                    margin: [0, 5],
                    fontSize: 11,
                    bold: true
                },
                bigHeader: {
                    alignment: 'center',
                    margin: [0, 0, 0, 10],
                    fontSize: 16,
                    bold: true
                },
                table: {
                    fontSize: 5,
                    margin: [0, 0, 0, 0],
                    border: '5px'
                },
                td: {
                    size: 1
                },
                text: {
                    fontSize: 9,
                    margin: [0, 0, 0, 0],
                },
            },
        };
        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.getBase64((result) => {
            setClientPdf(result);
        });
        // pdfDocGenerator.download(_ => {
        //
        // });
        pdfDocGenerator.getDataUrl((dataUrl) => {
            // const blob = b64toBlob(dataUrl, 'application/pdf');
            // const blobUrl = URL.createObjectURL(blob);

            // window.location = blobUrl;
            setDataUrl(dataUrl);
        });
        setLoading(false);
    }



    useEffect(() => {
        fetch();
    }, [])


    return (
        !loading
            ? <iframe src={dataUrl} style={{ width: '100%', minHeight: '900px' }}></iframe>
            : <CircularProgress size={200} />

    )
}